import ptbr from "./text_ptbr_main.json";
import en from "./text_en_main.json";

export const languages = {
    ptbr,
    en
};